import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreVertIcon from '@material-ui/icons/MoreVert'

const options = [{ id: 'delete', name: 'Delete' }]

class LongMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleClickMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleDelete = (event) => {
    const { onDelete } = this.props
    this.handleClose()
    onDelete()
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)

    return (
      <div>
        <IconButton aria-label="More" aria-owns={open ? 'long-menu' : undefined} aria-haspopup="true" onClick={this.handleClickMenu}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" anchorEl={anchorEl} open={open} onClose={this.handleClose}>
          {options.map((option) => (
            <MenuItem value={option.id} key={option.id} onClick={this.handleDelete}>
              {option.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    )
  }
}

export default LongMenu
